export default "__VITE_ASSET__CRMfUmAK__"